import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { lucideLayoutTemplate, lucideCheck } from '@ng-icons/lucide';
import { HlmBadgeDirective } from '@spartan-ng/helm/badge';
import { SolarTemplate } from '@features/catalog/models/template.model';

/** Per-row application state, so a caller that assigns on click can show progress. */
export type TemplatePickerState = 'idle' | 'applying' | 'applied' | 'error';

/**
 * Planning-template picker — the card list previously duplicated between
 * ExecutionPanel (campaign runs) and StartPlanningDialog (single analysis).
 *
 * Presentational: it renders templates and emits the chosen id. The assign call
 * stays with the caller, because it differs per context — a single analysis
 * PATCHes `selectedTemplateId`, a campaign bulk-assigns across a selection, and
 * the create dialog has no analysis id yet at selection time.
 */
@Component({
  selector: 'app-template-picker',
  standalone: true,
  imports: [NgIconComponent, HlmBadgeDirective],
  providers: [provideIcons({ lucideLayoutTemplate, lucideCheck })],
  templateUrl: './template-picker.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplatePicker {
  templates = input<SolarTemplate[]>([]);
  selectedTemplateId = input<string | null>(null);
  isLoading = input<boolean>(false);
  /** Load/assign failure text. Rendered under the list; null hides it. */
  error = input<string | null>(null);
  state = input<TemplatePickerState>('idle');

  templateSelected = output<string>();

  select(templateId: string): void {
    if (this.state() === 'applying') return;
    this.templateSelected.emit(templateId);
  }

  getTypeLabel(type: string): string {
    return type === 'lease' ? 'Miete' : 'Kauf';
  }
}
